import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API_URL from "../config";

export default function Scan() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("loading");
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");
    const token = localStorage.getItem("token");

    if (!token) {
      localStorage.setItem("redirectAfterLogin", `/scan?code=${code}`);
      return navigate("/login");
    }

    if (!code) {
      setStatus("error");
      setMessage("QR code invalide.");
      return;
    }

    fetch(`${API_URL}/api/fidelite/scan`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ code }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.passages) {
          setStatus("success");
          setMessage(data.bonusGagne
            ? `🎉 Félicitations ! Tu as gagné un service gratuit ! Total : ${data.passages} passages`
            : `✅ Passage enregistré ! Total : ${data.passages} passages`
          );
        } else {
          setStatus("error");
          setMessage(data.message);
        }
      })
      .catch(() => { setStatus("error"); setMessage("Erreur serveur."); });
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center">
        {status === "loading" && <p className="text-gray-500">Vérification...</p>}
        {status === "success" && (
          <>
            <div className="text-5xl mb-4">✅</div>
            <p className="text-green-700 font-semibold text-lg">{message}</p>
            <button onClick={() => navigate("/mon-compte")} className="mt-6 w-full py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Voir ma carte
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="text-5xl mb-4">❌</div>
            <p className="text-red-600 font-semibold text-lg">{message}</p>
            <button onClick={() => navigate("/mon-compte")} className="mt-6 w-full py-2.5 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">
              Retour
            </button>
          </>
        )}
      </div>
    </div>
  );
}